// Dependencies
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
// Actions
import { updateExternalReference } from './redux/actions';
// Types
import { AppState } from '../../reducers';
import { Circuit } from './objects/circuit';

type Props = {
    circuit: Circuit | null
}

export function CircuitExternalReference(props: Props): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const circuitData = useSelector((state: AppState) => state.circuit.circuit);
    const external_reference = useSelector((state: AppState) => state.circuit.external_reference);

    useEffect(() => {
        dispatch(updateExternalReference(external_reference || ''));
    },[circuitData]);

    const onExternalReferenceChange = (event: { target: { value: any; }; }) => {
        dispatch(updateExternalReference(event.target.value));
    };

    // recreate input
    useEffect(() => {
        if (props.circuit) {
            dispatch(updateExternalReference(props.circuit.external_reference ?? ''));
        }
    }, [props.circuit]);

    return (
        <FormControl fullWidth variant={ 'outlined' }>
            <TextField
                value={ external_reference }
                id={ 'circuit-external-reference' }
                label={ t('shared.personal-id') }
                onChange={ onExternalReferenceChange }
            />
        </FormControl>
    );
}

export default CircuitExternalReference;
